import { render, staticRenderFns } from "./TrackingMail.vue?vue&type=template&id=8abbf654&scoped=true&"
import script from "./TrackingMail.vue?vue&type=script&lang=ts&"
export * from "./TrackingMail.vue?vue&type=script&lang=ts&"
import style0 from "./TrackingMail.vue?vue&type=style&index=0&id=8abbf654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abbf654",
  null
  
)

export default component.exports